export interface ImageNaturalSize {
    width: number,
    height: number,
}

export interface ModifyEventConfig {
    preventDefault?: boolean,
    stopPropagation?: boolean,
    stopImmediatePropagation?: boolean,
}

/**
 * Different possible entries found in the [window.navigator.platform] value.
 */
export enum OperatingSystems {
    mac = 'Mac',
    ios = 'IOS',
    windows = 'Windows',
    android = 'Android',
    linux = 'Linux',
}

/**
 * Options for reading a file.
 */
export enum FileReadingOptions {
    binaryString = 'binaryString',
    dataUrl = 'dataUrl',
    text = 'text',
    arrayBuffer = 'arrayBuffer',
    json = 'json',
}
